import type { ReactNode } from 'react';
import { ContentListPageHeader } from './ContentListPageHeader';
import { SitePageReveal } from './SiteFadeIn';
import { panelMainClass } from '../lib/contentListPageLayout';

interface ContentListPagePanelsProps {
  contentReady: boolean;
  title: string;
  subtitle?: ReactNode;
  leftPanel?: ReactNode;
  rightPanel?: ReactNode;
  bodyContent: ReactNode;
  hasLeftPanel: boolean;
  hasRightPanel: boolean;
}

export function ContentListPagePanels({
  contentReady,
  title,
  subtitle,
  leftPanel,
  rightPanel,
  bodyContent,
  hasLeftPanel,
  hasRightPanel,
}: ContentListPagePanelsProps) {
  return (
    <SitePageReveal ready={contentReady}>
      <div className="content-list-panels">
        {hasLeftPanel && (
          <div className="content-list-panel-left hidden shrink-0 self-stretch lg:block">
            <div className="sticky top-20 pt-30">{leftPanel}</div>
          </div>
        )}
        <div className={panelMainClass(hasLeftPanel, hasRightPanel)}>
          <ContentListPageHeader title={title} subtitle={subtitle} />
          {bodyContent}
        </div>
        {hasRightPanel && (
          <div className="content-list-panel-right hidden shrink-0 self-stretch lg:block">
            <div className="sticky top-20 pt-30">{rightPanel}</div>
          </div>
        )}
      </div>
    </SitePageReveal>
  );
}
